/**
 * PAPARAN tarikh yang tidak bergantung pada bahasa browser (4 Okt 2026, arahan user).
 *
 * `toLocaleDateString()` / `toLocaleString()` TANPA locale mengikut bahasa browser: Chrome
 * berbahasa English (US) menulis "11/2/2026" untuk 2 Nov — pelanggan Malaysia membacanya
 * 11 Feb. Di sini bulan ditulis dengan HURUF ("2 Nov 2026") supaya hari/bulan tidak boleh
 * tertukar. Gaya sama dengan yang sedia ada pada kotak credit (FlowT2Kredit) dan tab admin.
 *
 *   lang 'en' → "3 Oct 2026"   ·   selain itu (BM) → "3 Okt 2026"
 *
 * ⚠️ PAPARAN sahaja — jangan guna hasilnya sebagai kunci, untuk dibanding atau disusun.
 * ⚠️ JANGAN panggil toLocaleDateString()/toLocaleString() tanpa locale untuk tarikh baharu;
 *    guna fungsi di bawah. (Nombor seperti `1,234` tidak terlibat.)
 * KEMBAR: sesaat (extension)/App.tsx — tarikh tamat lesen + README eksport (codebase berasingan).
 */
const lokal = (lang) => (lang === 'en' ? 'en-MY' : 'ms-MY');

/** Date | ms | rentetan ISO | Timestamp Firestore → Date sah, atau null (tiada "Invalid Date"). */
function keTarikh(v) {
    if (v === null || v === undefined || v === '' || v === 0) return null;
    const d = v instanceof Date ? v
        : typeof v.toDate === 'function' ? v.toDate()
            : Number.isFinite(v.seconds) ? new Date(v.seconds * 1000)
                : new Date(v);
    return d instanceof Date && !Number.isNaN(d.getTime()) ? d : null;
}

/** "2 Nov 2026". Nilai kosong / rosak → `kosong`. */
export function tarikhPapar(v, lang = 'en', kosong = '—') {
    const d = keTarikh(v);
    return d ? d.toLocaleDateString(lokal(lang), { day: 'numeric', month: 'short', year: 'numeric' }) : kosong;
}

/** "2 Nov 2026, 3:45 pm" (`saat: true` → tambah saat). Nilai kosong / rosak → `kosong`. */
export function tarikhMasaPapar(v, lang = 'en', { saat = false, kosong = '—' } = {}) {
    const d = keTarikh(v);
    return d ? d.toLocaleString(lokal(lang), {
        day: 'numeric', month: 'short', year: 'numeric',
        hour: 'numeric', minute: '2-digit', ...(saat ? { second: '2-digit' } : {}),
    }) : kosong;
}
